import React, { useMemo } from "react";
import { TextInput } from "react-native";

import { TextInputControlProps } from "./TextInputControl.types";
import { PasswordInput } from "../../../common";

export const PasswordControl = React.forwardRef(
  <T, P>(
    {
      getValidationClassName,
      onInputChange,
      control,
      formState,
      value,
      error,
      label,
      onSubmitEditing,
    }: TextInputControlProps<T, P>,
    ref: React.ForwardedRef<TextInput>,
  ): React.ReactElement => {
    const classNames = useMemo(() => {
      if (control?.classNames) {
        return [...getValidationClassName().classes].concat(control.classNames);
      } else {
        return [...getValidationClassName().classes, "input", "inputLarge"];
      }
    }, [getValidationClassName, control.classNames]);

    return (
      <PasswordInput
        ref={ref}
        label={label || ""}
        value={String(value)}
        onChangeText={onInputChange}
        onSubmitEditing={onSubmitEditing}
        disabled={!!control.disabledIf && control.disabledIf(formState)}
        classNames={classNames}
        message={error || ""}
        state={getValidationClassName().state}
        placeholder={control.placeholder}
      />
    );
  },
);
